import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // The default feedback belongs to visibly-labelled acquisition CTAs. Compact/icon controls
  // opt out with an explicit empty label so disabling never destroys their approved content.
  static values = { label: { type: String, default: "Acquiring…" } }

  disable(event) {
    if (event?.defaultPrevented) return
    const button = event?.submitter || this.element.querySelector("button[type='submit']")
    if (!button) return

    queueMicrotask(() => {
      button.disabled = true
      if (this.labelValue !== "" && button.textContent.trim() !== "") button.textContent = this.labelValue
    })
  }
}
